window.setMasterImage = function ($target, title) {
  var $image = $target.find('.js-master-background-image');
  if (title) {
    var encodedTitle = encodeURIComponent(title);
    $.ajax({url: '/master_keywords/' + encodedTitle, type: 'get'}).done(function (response) {
      if (response.error) {
        $image.css('background-image', 'url("/images/default-profile-image.png")');
      } else {
        $image.css('background-image', 'url(' + response.master_keyword.image_url + ')');
      }
    }).fail(function (response) {
      $image.css('background-image', 'url("/images/default-profile-image.png")');
    });
  } else {
    $image.css('background-image', 'url("/images/default-profile-image.png")');
  }
};
